import { SET_PREGUNTA_ACTIVA } from "../actions/types";

const INITIAL_STATE = { id_instrumento: 0, id_pregunta: 10101, contador: 0 };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PREGUNTA_ACTIVA:
            //console.log("Reducer Preguna Activa", action);
            return { ...action.payload };
        default:
            return state;
    }
};
